import React, { Suspense } from 'react';
import { ManagedPopup } from 'js/components/common/Popup';
import { useOnClose } from 'js/components/common/PopupManager';
import { GamblingSessionLimits } from 'js/components/main/GamblingSessionLimits';

import style from './GamblingSessionLimitsPopup.scss';

export const GamblingSessionLimitsPopup: React.FC<{
    id: string;
    onCancel?: () => void;
    onSuccessLimitsSet?: () => void;
}> = ({ id, onSuccessLimitsSet, onCancel }) => {
    const closePopup = useOnClose(id);

    return (
        <ManagedPopup
            id={id}
            isModal
            className={style.container}
            layerClassNames={{ layout: style.layout }}
            title="playtech.mobile.system.gamblingSessionLimits.title"
        >
            <Suspense fallback="">
                <GamblingSessionLimits
                    onCancel={onCancel}
                    closePopup={closePopup}
                    isActionDialogCheckDisabled
                    onSuccessLimitsSet={onSuccessLimitsSet}
                />
            </Suspense>
        </ManagedPopup>
    );
};
